<fgb-banner [pageTitle]="'terms.page.title' | translate" />

<fgb-page-header [pageTitle]="'terms.page.title'" [showBalance]="false" [backButtonLink]="'/'"></fgb-page-header>

<div class="container">
  <div class="mt-lg-3">
    <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="text-center bg-white font-size-14 mb-0">
    {{ 'default.terms.description' | translate }}
  </p>
</ng-template>
